/* eslint-disable import/no-cycle */
import Vue from 'vue';
import axios from 'axios';
import cookie from 'vue-cookie';
import store from '../store';
import ToastComponent from '../components/shared/ToastComponent.vue';

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(accessToken) {
  subscribers = subscribers.filter((callback) => callback(accessToken));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

const HTTP = axios.create({
  baseURL: 'https://api.zeyplay.com/coach/',
});

// Request interceptors
HTTP.interceptors.request.use(
  (config) => {
    const token = cookie.get('coach_token');

    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = token;
    }
    return Promise.resolve(config);
  },
  (error) => Promise.reject(error),
);

// response interceptors
HTTP.interceptors.response.use((response) => {
  if (response.data.message) {
    Vue.$toast.error({
      component: ToastComponent,
      props: {
        content: response.data.message,
      },
    });
  }
  return Promise.resolve(response);
}, (error) => {
  const { config, response: { status } } = error;

  const originalRequest = config;

  if (status === 401) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true;

      store.dispatch('updateToken').then((response) => {
        isAlreadyFetchingAccessToken = false;
        onAccessTokenFetched(response.access);
      });
    }
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber((accessToken) => {
        originalRequest.headers.Authorization = accessToken;
        resolve(HTTP(originalRequest));
      });
    });
    return retryOriginalRequest;
  }

  if (status === 403) {
    store.dispatch('logout');
  }

  if (status === 500) {
    Vue.$toast.error('500 ERR');
  }

  return Promise.reject(error);
});

export default HTTP;
